import { render, staticRenderFns } from "./loginEmbedded.vue?vue&type=template&id=07d2d6ba&"
import script from "./loginEmbedded.vue?vue&type=script&lang=js&"
export * from "./loginEmbedded.vue?vue&type=script&lang=js&"
import style0 from "./loginEmbedded.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
